// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.custom-ui {
  color: var(--undp-jtf-btn-dark-color);
}

.map-icon {
  border: 1px solid darkgrey;
  padding: 2px;
  margin-bottom: 7px;
  border-radius: 5px;
}

.flex-analysis-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 1.5em;
  margin-right: 1em;
  margin-left: 1em;
  align-items: center;
  gap: 2em;
  min-width: 80%;
}
@media (max-width: 775px) {
  .flex-analysis-wrapper {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
}

.flex-analysis-wrapper-filters {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
@media (max-width: 692px) {
  .flex-analysis-wrapper-filters {
    flex-direction: column;
    align-items: flex-start;
  }
}

.bottom_bar {
  display: flex;
  gap: 2em;
  flex-direction: row;
  align-items: center;
}
@media (max-width: 420px) {
  .bottom_bar {
    flex-wrap: wrap;
    gap: 1em;
  }
}

.flex-data-preferences-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 1.5em;
  margin-right: 1em;
  margin-left: 1em;
  align-items: center;
  gap: 1.2em;
}

@media (max-width: 992px) {
  .marg-left-2 {
    margin-left: 1em;
  }
  .flex-data-preferences-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 1em;
    margin-right: 1em;
    margin-left: 1em;
    align-items: center;
    gap: 0.5em;
  }
  .pad-left-1 {
    padding-left: 0.5em;
  }
}
.flex-custom-date-row {
  display: flex;
}

.marg-left-1 {
  margin-left: 1em;
}

.custom-report-duration:nth-last-child(2) {
  flex-grow: 1;
}

.report-text:last-of-type {
  width: 80px !important;
  padding: 0.2% !important;
}

.flex-charts-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 1em;
  margin-right: 1em;
  margin-left: 1em;
  align-items: center;
  gap: 2em;
}

.line-divider {
  margin-left: 5px;
  margin-right: 5px;
  height: 25px;
  width: 1px;
  background-color: #000000;
}

.add-more-charts-text {
  font-size: 13px;
  color: var(--undp-jtf-accent-color);
}

.custom-row-btn {
  width: auto;
}

.custom-btn {
  width: 83px !important;
  padding: 4% !important;
}

.flex-gap-row {
  gap: 2.5em;
}

.flex-gap-1 {
  gap: 1em;
}

.btn-report-group {
  display: flex;
}

.btn-outline-black {
  border: 1px solid #000000;
}

.btn-border {
  border-radius: 10px;
}

.btn-template-row-text {
  font-size: 16px;
}

.btn-border-report {
  border-radius: 20px;
  border: 1px solid var(--undp-jtf-btn-dark-color);
}

.add-more-charts-text {
  font-size: 13px;
  color: var(--undp-jtf-accent-color);
}

.btn-outline-black:hover {
  background-color: var(--undp-jtf-accent-color);
}

.btn-outline-report:hover {
  background-color: #92d46a;
  border: 1px solid #92d46a;
  color: #ffffff;
}

.btn-outline-report:focus {
  background-color: #92d46a;
  border: 1px solid #92d46a;
  color: #ffffff;
}

.button-selected {
  background-color: #add8e6;
  border: 1px solid #add8e6;
  color: #ffffff !important;
}

.font-report-text {
  font-size: 14px;
}

.marg-left-2 {
  margin-left: 2em;
}

.marg-left-1 {
  margin-left: 1em;
}

.pad-left-1 {
  padding-left: 1em;
}

.label-line-height {
  line-height: 2.5rem;
}

.custom-btn-outline-primary.disabled,
.custom-btn-outline-primary:disabled {
  color: #000000 !important;
  background-color: transparent !important;
  border: 1px solid #000000;
}

.custom-btn-outline-primary {
  color: #000000;
  border-color: #000000;
}

.custom-btn-outline-primary:not(:disabled):hover {
  color: #ffffff;
  background-color: var(--undp-jtf-accent-color);
  border: none;
}

.flex-forms-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 1.5em;
  align-items: center;
  gap: 2em;
  min-width: 80%;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/post-filters/components/post-filters.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACGA;EACE,qCAAA;AACF;;AAEA;EACE,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AACF;AACE;EAZF;IAaI,8BAAA;IACA,uBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAEF;AAAE;EANF;IAOI,sBAAA;IACA,uBAAA;EAGF;AACF;;AADA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;AAIF;AAFE;EANF;IAOI,eAAA;IACA,QAAA;EAKF;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AAEF;;AACA;EAEE;IACE,gBAAA;EACF;EACA;IACE,aAAA;IACA,mBAAA;IACA,eAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,UAAA;EACF;EACA;IACE,mBAAA;EACF;AACF;AAEA;EACE,aAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAIA;EACE,sBAAA;EACA,wBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AADF;;AAIA;EACE,eAAA;EACA,mCAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAKA;EACE,sBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,QAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gDAAA;AAFF;;AAKA;EACE,eAAA;EACA,mCAAA;AAFF;;AAKA;EACE,8CAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;;EAEE,yBAAA;EACA,wCAAA;EACA,yBAAA;AAFF;;AAKA;EACE,cAAA;EACA,qBAAA;AAFF;;AAKA;EACE,cAAA;EACA,8CAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAFF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n\n\n.custom-ui{\n  color: var(--undp-jtf-btn-dark-color);\n}\n\n.map-icon {\n  border: 1px solid darkgrey;\n  padding: 2px;\n  margin-bottom: 7px;\n  border-radius: 5px;\n}\n\n.flex-analysis-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-top: 1.5em;\n  margin-right: 1em;\n  margin-left: 1em;\n  align-items: center;\n  gap: 2em;\n  min-width: 80%;\n\n  @media (max-width: 775px) {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n  }\n}\n\n.flex-analysis-wrapper-filters {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n\n  @media (max-width: 692px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n.bottom_bar{\n  display: flex;\n  gap:2em;\n  flex-direction: row;\n  align-items: center;\n\n  @media (max-width: 420px) {\n    flex-wrap: wrap;\n    gap: 1em;\n  }\n}\n// .top_bar{\n//   // position: block;\n//   // right: 50px;\n// }\n.flex-data-preferences-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 1.5em;\n  margin-right: 1em;\n  margin-left: 1em;\n  align-items: center;\n  gap: 1.2em;\n}\n\n@media (max-width: 992px) {\n\n  .marg-left-2 {\n    margin-left: 1em;\n  }\n  .flex-data-preferences-wrapper {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-top: 1em;\n    margin-right: 1em;\n    margin-left: 1em;\n    align-items: center;\n    gap: 0.5em;\n  }\n  .pad-left-1 {\n    padding-left: 0.5em;\n  }\n}\n\n.flex-custom-date-row {\n  display: flex;\n}\n\n.marg-left-1 {\n  margin-left: 1em;\n}\n\n.custom-report-duration:nth-last-child(2) {\n  flex-grow: 1;\n  // margin-bottom: 0.5rem;\n}\n\n.report-text:last-of-type {\n  width: 80px !important;\n  padding: 0.2% !important;\n}\n\n.flex-charts-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 1em;\n  margin-right: 1em;\n  margin-left: 1em;\n  align-items: center;\n  gap: 2em;\n}\n\n.line-divider {\n  margin-left: 5px;\n  margin-right: 5px;\n  height: 25px;\n  width: 1px;\n  background-color: #000000;\n}\n\n.add-more-charts-text {\n  font-size: 13px;\n  color: var(--undp-jtf-accent-color);\n}\n\n.custom-row-btn {\n  width: auto;\n // padding: 1.5%;\n}\n\n.custom-btn {\n  width: 83px !important;\n  padding: 4% !important;\n}\n\n.flex-gap-row {\n  gap: 2.5em;\n}\n\n.flex-gap-1 {\n  gap: 1em;\n}\n\n.btn-report-group {\n  display: flex;\n}\n\n.btn-outline-black {\n  border: 1px solid #000000;\n}\n\n.btn-border {\n  border-radius: 10px;\n}\n\n.btn-template-row-text {\n  font-size: 16px;\n}\n\n.btn-border-report {\n  border-radius: 20px;\n  border: 1px solid var(--undp-jtf-btn-dark-color);\n}\n\n.add-more-charts-text {\n  font-size: 13px;\n  color: var(--undp-jtf-accent-color);\n}\n\n.btn-outline-black:hover {\n  background-color: var(--undp-jtf-accent-color);\n}\n\n.btn-outline-report:hover {\n  background-color: #92d46a;\n  border: 1px solid #92d46a;\n  color: #ffffff;\n}\n\n.btn-outline-report:focus {\n  background-color: #92d46a;\n  border: 1px solid #92d46a;\n  color: #ffffff;\n}\n\n.button-selected {\n  background-color: #add8e6;\n  border: 1px solid #add8e6;\n  color: #ffffff !important;\n}\n\n.font-report-text {\n  font-size: 14px;\n}\n\n.marg-left-2 {\n  margin-left: 2em;\n}\n\n.marg-left-1 {\n  margin-left: 1em;\n}\n\n.pad-left-1 {\n  padding-left: 1em;\n}\n\n.label-line-height {\n  line-height: 2.5rem;\n}\n\n.custom-btn-outline-primary.disabled,\n.custom-btn-outline-primary:disabled {\n  color: #000000 !important;\n  background-color: transparent !important;\n  border: 1px solid #000000;\n}\n\n.custom-btn-outline-primary {\n  color: #000000;\n  border-color: #000000;\n}\n\n.custom-btn-outline-primary:not(:disabled):hover {\n  color: #ffffff;\n  background-color: var(--undp-jtf-accent-color);\n  border: none;\n}\n\n.flex-forms-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 1.5em;\n  align-items: center;\n  gap: 2em;\n  min-width: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
